import React, { useState} from 'react';

function TableContact(props) {
    const [donnée] = useState(props.userData.user.contact);



  return (
  <>

    <h2 className="admin_">Messages des utilisateurs</h2>
    <table id='admin'>
        <thead>
            <tr>
            <th scope="col">id</th>
            <th scope="col">Nom</th>
            <th scope="col">Email</th>
            <th scope="col">Message</th>
            </tr>
        </thead>
        <tbody>
            {donnée && donnée.results && donnée.results.map((item, index) => (
                <tr key={index}>
                    <td data-label="id">{item.id}</td>
                    <td data-label="nom">{item.nom}</td>
                    <td data-label="email">{item.email}</td>
                    <td data-label="message">{item.message}</td>
                </tr>
            ))}
        </tbody>
    </table>

   </> 

    );
}

export default TableContact;